<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
  Program: main page
  Author: SDL
  Brief: main layout template
-->
<template>
  <div
    id="mainWrapperDiv"
    class="ui--wrapper fluid-width"
    :class="{
      'ui---lnb-collapsed': isFoldSideMenu,
      // 'aside-hide': isHideSideMenu,
      's-main': isHideSideMenu,
      'ui---lnb': !isHideSideMenu,
    }"
  >
    <!--aside-hide aside-collapsed-->
    <!-- GNB -->
    <top-menu @router-reload="routerReload()"></top-menu>
    <!-- SUB Layout -->
    <section class="ui--section-container" v-bind:style="styleSet" >
      <!-- SUB Contents -->
      <router-view v-if="isRouterAlive"></router-view>
      <!-- LEFT Navigtion -->
      <side-menu
        v-if="!isHideSideMenu"
        @router-reload="routerReload()"
        @fold-event="isFoldSideMenu = !isFoldSideMenu"
        @hide-event="displaySideMenu"
      />
      <!-- Offsider -->
      <offsider @router-reload="routerReload()"></offsider>
    </section>
    <!-- Footer -->
    <!-- <footer class="ui--footer-container">
      <div class="ui--footer-in">
        <span>&copy; Samsung</span>
        <a class="ml-3" href="javascript:" @click="showTermPopup('PERSONAL_USE', $event)">{{
          $t('sdl.privacyPolicy.policy')
        }}</a>
        <span class="ml-1 mr-1 ui--slide">|</span>
        <a href="javascript:" @click="showTermPopup('AGREE_USE', $event)">{{ $t('sdl.privacyPolicy.termsUse') }}</a>
      </div>
    </footer> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import TopMenu from './MainTopMenu';
import SideMenu from './MainSideMenu';
import Offsider from './MainOffsider';
import { SDLUtil } from '@/utils';
import TermPopup from '@/components/common/popup/TermPopup';

export default {
  name: 'Main',
  components: {
    TopMenu,
    SideMenu,
    Offsider,
  },
  data() {
    return {
      isFoldSideMenu: false,
      isHideSideMenu: false,
      isRouterAlive: true,
      styleSet: {},
    };
  },
  computed: {
    ...mapGetters({
      locale: 'getLocale',
    }),
  },
  methods: {
    ...mapActions(['getMenus']),
    displaySideMenu(flag) {
      this.isHideSideMenu = flag;
    },
    routerReload() {
      this.isRouterAlive = false;
      setTimeout(() => {
        this.isRouterAlive = true;
      });
    },
    showTermPopup(termsTypeCode, event) {
      SDLUtil.showLoadingBar(true);
      const title = event.currentTarget.textContent;
      axios
        .get(`${SDLUtil.API_URL}/privacypolicy/terms/${termsTypeCode}/valid?langType=${this.locale}`)
        .then(({ data }) => {
          SDLUtil.show(
            TermPopup,
            {
              title,
              term: data,
            },
            {
              width: 1000,
              height: 850,
            },
          );
          SDLUtil.showLoadingBar(false);
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
        });
    },
  },
  watch: {
    $route() {
      this.isHideSideMenu = this.$route.meta.menuId === undefined;
    },
  },
  created() {
    // document.querySelector('body').classList.remove('ui--login-wrap', 'sdl-wrap');
    // Hide side menu area without menuId
    this.isHideSideMenu = this.$route.meta.menuId === undefined;
    if (document.location.origin.indexOf('localhost') <= 0) {
      this.styleSet = { 'padding-top': '0px' };
    }
  },
  beforeCreate() {
    const redirect = this.$router.history.current.query.redirect || '';
    if (redirect) {
      this.$router.replace(redirect);
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    $('[data-toggle="tooltip"]').tooltip();
  },
  updated() {
    // eslint-disable-next-line no-undef
    $('[data-toggle="tooltip"]').tooltip();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/admin/main/MainPage.vue